import { render, staticRenderFns } from "./BbeeProductosServiciosGE.vue?vue&type=template&id=056f77cf"
import script from "./BbeeProductosServiciosGE.vue?vue&type=script&lang=js"
export * from "./BbeeProductosServiciosGE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports